import React from 'react';
import "./../App.css";
import { Card, Form, Button, Col} from 'react-bootstrap';
import { wmsService } from "../services/wmsService"
import Scanner from "./Scanner";

class PutAwayToBin extends React.Component {
    constructor(props) {
        super(props);
        this.state = {    
            pallet: null,
            wmsitm: [],
            showScanner: false,
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.goBack = this.goBack.bind(this);        
        this.onNewScanResult = this.onNewScanResult.bind(this);  
        this.scan = this.scan.bind(this);    
        this.closeScanner = this.closeScanner.bind(this);
    }

    componentDidMount() {         
    }

    handleInputChange = (event) => {    
        const target = event.target;
        const name = target.id;   
        this.setState({
          [name]: target.value
        });   
      }

    handleSubmit(e) {
        e.preventDefault();
        console.log(this.state.pallet);
        // Check whether we have received items in this pallet. If not then alert, otherwise move to next screen
        let user = JSON.parse(localStorage.getItem('user'));                 
        wmsService.getActiveWmsByLicense(this.state.pallet, user.config.inventoryLocation).then(witm => {
            if (witm && witm === 401) {
                this.props.history.push("/login");
            } else if (witm && witm.length > 0) {
                console.log('got date from getActiveWmsByPallete...', witm);
                this.state.wmsitm = witm;
                
                let wmsempactivityreport = {};
                wmsempactivityreport.invlocation = user.config.inventoryLocation;
                wmsempactivityreport.wmsorder = witm[0].srcorder;
                wmsempactivityreport.employee = user.username
                wmsempactivityreport.type = 5;
                wmsempactivityreport.starttime = (new Date()).toISOString();
                this.state.wmsempactivityreport = wmsempactivityreport;

                if (witm.length == 1) {
                    var { from } = { from: { pathname: "/assingtobin" } };  
                } else {
                    var { from } = { from: { pathname: "/palletitems" } };  
                }
                this.props.history.push(from, this.state);                      
            } else {
                alert('Pallet ' + this.state.pallet + ' is not found! Please enter another Pallet.');
            }
        });


        
        
    }
    
    goBack =() => {
        console.log(this.props);
        this.props.history.goBack();
    }

    scan =() => {
        console.log('Scan is called');
    }

    render() {        
        return (
            
            <div>                
                <Card>
                    <Card.Header>Putaway Goods                        
                    </Card.Header>
                    <Card.Body>
                    <Form onSubmit={this.handleSubmit}>
                        
                        <Form.Row>
                            <Form.Group as={Col} controlId="pallet" 
                                onChange={this.handleInputChange}>
                            <Form.Label style={{fontSize: "14px"}}>License Plate</Form.Label>
                            <Form.Control required={true} placeholder="Scan or enter license plate" value={this.state.pallet} autoFocus s/>
                            </Form.Group>
                        </Form.Row> 
                        <div style={{float: "left"}} >                                       
                        <Button variant="outline-primary mr-3" size="sm" type="submit">Next</Button>                              
                        <Button variant="outline-primary mr-3" size="sm" type="button" onClick={() => {this.scan()}}>Scan</Button>                              
                        <Button variant="outline-primary mr-3" size="sm" type="button" onClick={() => {this.goBack()}}>Cancel</Button>                              
                        </div>
                      </Form>
                      <Scanner showScanner={this.state.showScanner} closeScanner={this.closeScanner} onNewScanResult={this.onNewScanResult}></Scanner>
                    </Card.Body>
                </Card>
            </div>
            
        );
    }
    scan =() => {
        //console.log('Scan item is called');        
        this.setState({showScanner: true});
    }
    
    closeScanner() {
        this.setState({showScanner: false})
    }

    onNewScanResult(decodedText, decodedResult) {
        // Handle the result here.
        console.log('Scanned Result', decodedText, decodedResult);  
        this.setState({showScanner: false, pallet: decodedText}); 
    } 
}
export default PutAwayToBin;